import { render, staticRenderFns } from "./ReceivedCallTable.vue?vue&type=template&id=0704e384&scoped=true"
import script from "./ReceivedCallTable.vue?vue&type=script&lang=js"
export * from "./ReceivedCallTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704e384",
  null
  
)

export default component.exports